(() => {
  const isVisible = (element) => element && !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);

  const getActiveVideoInsert = (mediaRoot) => {
    const inserts = mediaRoot.querySelectorAll('video-intersection-insert');
    for (const insert of inserts) {
      if (isVisible(insert)) return insert;
    }
    return inserts[0] || null;
  };

  const getActiveNativeVideo = (mediaRoot) => {
    const videos = mediaRoot.querySelectorAll('video');
    for (const video of videos) {
      if (isVisible(video)) return video;
    }
    return videos[0] || null;
  };

  const isPlaying = (mediaRoot) => {
    const videoInsert = getActiveVideoInsert(mediaRoot);
    if (videoInsert) return !!videoInsert._isPlaying;

    const video = getActiveNativeVideo(mediaRoot);
    return video ? !video.paused && !video.ended : false;
  };

  const playMedia = (mediaRoot) => {
    mediaRoot.querySelector('[data-sa-media-poster]')?.classList.add('hidden');

    const videoInsert = getActiveVideoInsert(mediaRoot);
    if (videoInsert) {
      if (!videoInsert._loaded && typeof videoInsert.loadMedia === 'function') {
        videoInsert.loadMedia();
      }
      if (typeof videoInsert.playMedia === 'function') {
        videoInsert.playMedia();
      }
      return;
    }

    const video = getActiveNativeVideo(mediaRoot);
    if (!video) return;

    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {});
    }
  };

  const pauseMedia = (mediaRoot) => {
    const videoInsert = getActiveVideoInsert(mediaRoot);
    if (videoInsert && typeof videoInsert.pauseMedia === 'function') {
      videoInsert.pauseMedia();
      return;
    }

    getActiveNativeVideo(mediaRoot)?.pause();
  };

  const syncButtonState = (mediaRoot, button) => {
    const playing = isPlaying(mediaRoot);
    const playIcon = button.querySelector('[data-sa-media-banner-icon-play]');
    const pauseIcon = button.querySelector('[data-sa-media-banner-icon-pause]');

    button.setAttribute('aria-pressed', playing ? 'true' : 'false');
    button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');

    playIcon?.classList.toggle('hidden', playing);
    pauseIcon?.classList.toggle('hidden', !playing);
  };

  const initProductMediaBanner = (root) => {
    root.querySelectorAll('[data-sa-media-banner-play]').forEach((button) => {
      if (button.dataset.saMediaBannerPlayBound === 'true') return;
      button.dataset.saMediaBannerPlayBound = 'true';

      const mediaRoot = button.closest('[data-sa-media-banner-media]');
      if (!mediaRoot) return;

      button.addEventListener('click', () => {
        if (isPlaying(mediaRoot)) {
          pauseMedia(mediaRoot);
        } else {
          playMedia(mediaRoot);
        }
        syncButtonState(mediaRoot, button);
      });

      mediaRoot.querySelectorAll('video').forEach((video) => {
        video.addEventListener('play', () => syncButtonState(mediaRoot, button));
        video.addEventListener('pause', () => syncButtonState(mediaRoot, button));
        video.addEventListener('ended', () => syncButtonState(mediaRoot, button));
      });

      syncButtonState(mediaRoot, button);
    });
  };

  const boot = (scope = document) => {
    scope.querySelectorAll('.sa-product-media-banner').forEach(initProductMediaBanner);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) boot(event.target);
  });
})();
